const ASSESSMENT_TYPES = {
  WEBAPP: 1,
  REHEARSAL: 2,
  DEMO: 3,
  PREVIEW: 4,
}

Object.freeze(ASSESSMENT_TYPES)

export { ASSESSMENT_TYPES }